export const ticketIssue = [
  { value: '3 years loss runs' },
  { value: "MVR's for all drivers" },
  { value: 'Connect ELD/Camera' },
  { value: 'Insured Payment Needed' },
  { value: 'DOT Safety Manual' },
  { value: "Driver Count on SAFER Doesn't Match" },
  { value: "Units on SAFER Don't Match" },
  { value: 'Ineligible Cargo On SAFER' },
  { value: 'DOT Number Incorrect' },
  { value: 'Address On Policy different than SAFER' },
  { value: 'Detailed/Precise Items the insured is Hauling' },
  { value: 'Insured is linked to 1 or more other entities' },
  { value: 'Proof of Prior Ins Needed' },
  { value: 'Proof of Companion Policy Needed' },
  { value: 'Proof of Registration Needed' },
  { value: 'Bill of Sale or Lease Termination Document needed' },
  { value: 'Statement of No loss needed' },
  { value: 'Other' },
];
